import {Theme, useMediaQuery} from '@mui/material'

export const useMobile = () => {
    const print = useMediaQuery('print')
    return useMediaQuery((theme: Theme) => theme.breakpoints.only('xs')) && !print
}
